import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import WrappingContainer from '../../HOC/WrappingContainer/WrappingContainer';
import ApplicantLogs from '../../Moecules/Applicants/ApplicantLogs/ApplicantLogs';
import logsIcon from '../../../assets/Imagess/logsIcon.svg';
import notesIcon from '../../../assets/Imagess/notesIcon.svg';
import campaignIcon from '../../../assets/Imagess/Campaign/campaignTabIcon.svg';
import emailTabIcon from '../../../assets/Imagess/Campaign/emailTabIcon.svg';
import referenceTabICon from '../../../assets/Imagess/referenceIConTab.png';
import inacactiveonline from '../../../assets/Imagess/inACtiveOnlineIcon.svg';
import EmailModal from '../../Moecules/Settings/SettingsModal/EmailModal';
import { useFetchSingleInterested } from '../../../Hooks/Interested';
import { useFetchSingleApplicant } from '../../../Hooks/Applicant';
import Documents from '../../Moecules/Applicants/Documents/Documents';
import inactiveDocumentTabIcon from '../../../assets/Imagess/inActiveDocumentTab.svg';
import OnlineFormContainer from '../../Moecules/Applicants/OnlineFormContainer/OnlineFormContainer';
import NotesContainer from '../../Moecules/Applicants/Notes/NotesContainer';
import ReferenceMolecule from '../../Moecules/Applicants/Reference/ReferenceMolecule';
import SingleApplicantTopHeader from '../../Moecules/SingleApplicant/SingleApplicantTopHeader';
import SingleApplicantNav from '../../Moecules/SingleApplicant/SingleApplicantNav';
import sendEmailICon from '../../../assets/Imagess/sendemailicon.svg';
import ApplicantCampaign from '../../Moecules/Applicants/ApplicantCampaign/ApplicantCampaign';
import EmailsReceivedContainer from '../../Moecules/Settings/ContactDetails/EmailsReceived/EmailsReceivedContainer';
import { useReactToPrint } from 'react-to-print';
import PrintComponent from '../../Moecules/Custom/ExportComponent/PrintComponent';
import { useApplicantContext } from '../../../Context/ApplicantContext';

const SingleApplicantPAge = () => {
  const { id } = useParams();
  const printRef = useRef();
  const location = useLocation();

  const { isApplicant, setIsApplicant } = useApplicantContext();

  const [applicant, setApplicant] = useState();
  const [selected, setSelected] = useState('online form');
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [isProspectLead, setIsProspectLead] = useState(false);
  const {
    data: interested,
    refetch: refetchInterested,
    isLoading: isInterestedLoading,
  } = useFetchSingleInterested({
    id: id,
    isInterested: isApplicant ? false : true,
  });
  const {
    data: singleApplicant,
    refetch: refetchApplicant,
    isLoading: isApplicantLoading,
  } = useFetchSingleApplicant({ id: id, isApplicant: isApplicant });

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const handleOpenEmailModal = () => {
    setShowEmailModal(true);

    setSelectedApplicants([{ id: id }]);
  };
  useEffect(() => {
    if (location.pathname.includes('/applicants')) {
      setIsApplicant(true);
    } else if (location.pathname.includes('/interested')) {
      setIsApplicant(false);
    }
  }, [location.pathname, setIsApplicant]);

  useEffect(() => {
    if (isApplicant) {
      setApplicant(singleApplicant?.data);
    } else {
      setApplicant(interested?.data);
    }
  }, [isApplicant, id, interested, singleApplicant]);

  useEffect(() => {
    if (
      (applicant?.applicantLeadLogs &&
        applicant?.applicantLeadLogs?.length !== 0 &&
        isApplicant) ||
      (applicant?.applicantLeadNotes &&
        applicant?.applicantLeadNotes?.length !== 0 &&
        isApplicant)
    ) {
      setIsProspectLead(true);
    }
  }, [applicant]);

  //tabs container
  const singleTabContainer = [
    {
      text: 'Online Form',
      value: 'online form',
      icon: inacactiveonline,
      content: (
        <OnlineFormContainer
          applicant={applicant}
          isApplicant={isApplicant}
          isLoading={isApplicant ? isApplicantLoading : isInterestedLoading}
          refetch={isApplicant ? refetchApplicant : refetchInterested}
        />
      ),
    },
    {
      text: 'Logs',
      value: 'Logs',
      icon: logsIcon,
      content: (
        <ApplicantLogs
          logs={applicant?.logs}
          isProspectLead={isProspectLead}
          applicantLeadLogs={applicant?.applicantLeadLogs}
        />
      ),
    },
    {
      text: 'Notes',
      value: 'Notes',
      icon: notesIcon,
      isNotes:
        applicant?.applicantNotes?.length ||
        applicant?.applicantLeadNotes?.length,
      content: (
        <NotesContainer
          isApplicant={isApplicant}
          notes={applicant?.applicantNotes}
          id={
            isApplicant
              ? applicant?.intersted?.applicantId
              : applicant?.intersted?.studentId
          }
          refetch={isApplicant ? refetchApplicant : refetchInterested}
          isProspectLead={isProspectLead}
          applicantLeadNotes={applicant?.applicantLeadNotes}
        />
      ),
    },
    ...(isApplicant
      ? [
          {
            text: 'Documents',
            value: 'Documents',
            icon: inactiveDocumentTabIcon,
            content: <Documents data={applicant} />,
          },
        ]
      : []),
    ...(isApplicant
      ? [
          {
            text: 'Reference',
            value: 'Reference',
            icon: referenceTabICon,
            content: <ReferenceMolecule data={applicant} />,
          },
        ]
      : []),
    {
      text: 'Campaigns',
      value: 'Campaigns',
      icon: campaignIcon,
      content: <ApplicantCampaign campaign={applicant?.campaigns} />,
    },
    {
      text: 'Emails',
      value: 'Emails',
      icon: emailTabIcon,
      content: (
        <EmailsReceivedContainer
          notifications={applicant?.notifications}
          mails={applicant?.allMail}
          refetch={isApplicant ? refetchApplicant : refetchInterested}
          setSelected={setSelected}
        />
      ),
    },
  ];
  const isNotesNotEmpty =
    applicant?.applicantNotes?.length || applicant?.applicantLeadNotes?.length;
  return (
    <>
      <WrappingContainer>
        <PrintComponent ref={printRef}>
          <SingleApplicantTopHeader
            data={applicant?.intersted}
            isProspectLead={applicant?.applicantLeadLink}
            isUnsubscribed={applicant?.applicantUnsubscribed?.length > 0}
            rightComponent={[
              {
                icon: sendEmailICon,
                text: 'Send Email',
                handleFunction: handleOpenEmailModal,
              },
            ]}
            bottomLeftComponent={[]}
            isLoading={isInterestedLoading || isApplicantLoading}
          />
          <SingleApplicantNav
            tabContainer={singleTabContainer}
            selected={selected}
            setSelected={setSelected}
            applicant={applicant}
            handlePrint={handlePrint}
          />

          <div>
            {
              singleTabContainer.find((item) => item.value === selected)
                ?.content
            }
          </div>
        </PrintComponent>
      </WrappingContainer>
      {showEmailModal && (
        <EmailModal
          handleOnClose={() => setShowEmailModal(false)}
          title='Send Email'
          selectedApplicants={selectedApplicants}
          setSelectedApplicants={setSelectedApplicants}
          refetchData={isApplicant ? refetchApplicant : refetchInterested}
          isApplicant={isApplicant}
        />
      )}
    </>
  );
};

export default SingleApplicantPAge;
